const _temp0 = require("./enso_2.webp");
const _temp1 = require("./main.webp");
module.exports = {
  "enso_2": _temp0,
  "main": _temp1
}